import React from 'react';
import { Button } from '../../../components/ui/button';
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from '../../../components/ui/select';
import {
  Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle,
} from '../../../components/ui/dialog';
import { SETTABLE_STATUS_ENTRIES } from './ordersConstants';

export const BatchUpdateDialog = ({ open, onOpenChange, count, batchStatus, setBatchStatus, onConfirm }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent>
      <DialogHeader>
        <DialogTitle>Batch Update Status</DialogTitle>
        <DialogDescription className="sr-only">Batch Update Status dialog. Use the form below to continue.</DialogDescription>
      </DialogHeader>
      <div className="space-y-4 pt-4">
        <p className="text-gray-600">
          Update <strong>{count}</strong> selected order(s) to:
        </p>
        <Select value={batchStatus} onValueChange={setBatchStatus}>
          <SelectTrigger>
            <SelectValue placeholder="Select new status" />
          </SelectTrigger>
          <SelectContent>
            {SETTABLE_STATUS_ENTRIES.map(([key, config]) => (
              <SelectItem key={key} value={key}>{config.label}</SelectItem>
            ))}
          </SelectContent>
        </Select>
        <div className="flex justify-end gap-2 pt-4">
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button
            className="bg-amber-500 hover:bg-amber-600"
            onClick={onConfirm}
            disabled={!batchStatus}
          >
            Update All
          </Button>
        </div>
      </div>
    </DialogContent>
  </Dialog>
);
